import $ from 'jquery';

document.querySelectorAll('form.cart [data-purchase-price]').forEach(price => {
    const form = price.closest('form.cart');
    const factor = 10 ** Number(price.dataset.decimals);
    const formatter = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: price.dataset.currency, minimumFractionDigits: Number(price.dataset.decimals) });
    let amount = Number(price.dataset.amount);
    let estimated = price.dataset.estimated === 'true';
    let addonsTotal = null;
    const render = () => {
        const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
        price.textContent = addonsTotal ?? `${estimated ? 'od ' : ''}${formatter.format(amount * quantity / factor)}`;
    };
    const variantPrice = variant => {
        amount = Math.round(Number(variant.display_price) * factor);
        estimated = false;
        render();
    };
    $(form).on('found_variation.ravessaPurchasePrice', (event, variant) => variantPrice(variant));
    $(form).on('reset_data.ravessaPurchasePrice', () => {
        amount = Number(price.dataset.amount);
        estimated = price.dataset.estimated === 'true';
        render();
    });
    $(form).on('input.ravessaPurchasePrice change.ravessaPurchasePrice', '[name="quantity"]', render);
    form.addEventListener('ravessa:addons-total', event => {
        // The addons component owns the quoted total, including every discount and gift.
        addonsTotal = event.detail;
        render();
    });
    const variations = $(form).data('product_variations');
    const selectedId = Number(form.querySelector('[name="variation_id"]')?.value);
    const selected = Array.isArray(variations) && variations.find(variant => variant.variation_id === selectedId);
    if (selected) variantPrice(selected);
    else render();
});
